import {
  ADD_BILLING_RULE_FORM_STEPS,
  ADD_PARKER_FORM_STEPS,
  ADD_PARKING_ALLOCATION_STEPS,
  CURRENCIES,
  DIALING_CODES,
} from "../enums/Enums";
import Strings from "../resources/Strings";

export const getGreetingValue = () => {
  const hours = new Date().getHours();
  let greetingValue = "";

  if (hours >= 6 && hours < 12) {
    greetingValue = Strings.GOOD_MORNING;
  } else if (hours >= 12 && hours < 18) {
    greetingValue = Strings.GOOD_AFTERNOON;
  } else {
    greetingValue = Strings.GOOD_EVENING;
  }

  return greetingValue;
};
export const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

export const getImageFromBase64 = (image) => {
  return `data:image/jpeg;base64,${image}`;
};

export const getDurationBetweenTwoDates = (date_future, date_now) => {
  // get total seconds between the times
  var delta = Math.abs(date_future - date_now) / 1000;

  // calculate (and subtract) whole days
  var days = Math.floor(delta / 86400);
  var displayDays = days ? `${days}d` : "";
  delta -= days * 86400;

  // calculate (and subtract) whole hours
  var hours = Math.floor(delta / 3600) % 24;
  var displayHours = hours ? `${hours}h` : "";
  delta -= hours * 3600;

  // calculate (and subtract) whole minutes
  var minutes = Math.floor(delta / 60) % 60;
  var displayMinutes = `${minutes}m`;
  delta -= minutes * 60;

  return `${displayDays} ${displayHours} ${displayMinutes}`;
};

export const getHoursFromSeconds = (seconds) => {
  return seconds / (60 * 60);
};

export const convertUTCToLocalTime = (utcDateString) => {
  let date = new Date(utcDateString);

  const milliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );

  const localTime = new Date(milliseconds);
  localTime.getDate();
  localTime.getHours();
  return localTime;
};

export const getTimePeriod = (datetime) => {
  return datetime.getUTCHours() >= 12 ? "PM" : "AM";
};

export const getDateFormat = (date) => {
  return (
    ("0" + (date.getUTCMonth() + 1)).slice(-2) +
    "." +
    ("0" + date.getUTCDate()).slice(-2) +
    "." +
    date.getUTCFullYear()
  );
};

export const getISODateStringFromDurationString = (durationString) => {
  if (!durationString) {
    return durationString;
  }

  const timeParts = durationString.split(" ");
  let days = 0;
  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  timeParts.forEach(timePart => {
    let timeUnit = timePart.slice(-1);

    switch (timeUnit) {
      case 'd':
        days = timePart.slice(0, -1);
        break;
      case 'h':
        hours = timePart.slice(0, -1);
        break;
      case 'm':
        minutes = timePart.slice(0, -1);
        break;
      case 's':
        seconds = timePart.slice(0, -1);
        break;
      default:
        break;
    }
  });

  return new Date(1901, 1, days, hours, minutes, seconds).toISOString();
};

export const getDateFromTimeString = (timeString) => {
  const timeParts = timeString.split(":");
  let timeObject = new Date();
  if (timeParts.length === 3) {
    timeObject = new Date(1901, 1, 1, timeParts[0], timeParts[1], timeParts[2]);
  }

  return timeObject;
};

export const getAmPmTimeFormatFromTimeString = (timeString) => {
  const timeParts = timeString.split(":");
  let timeObject = new Date();
  if (timeParts.length === 3) {
    timeObject = new Date(1901, 1, 1, timeParts[0], timeParts[1], timeParts[2]).toLocaleTimeString(timeObject);
  }

  // after converting date to string, merging time parts to correct format
  let timeSuffix = timeObject.slice(-2); // represents AM / PM
  let hours = parseInt(timeObject.split(":")[0]);
  let minutes = parseInt(timeObject.split(":")[1]);

  if (hours < 10) {
    hours = "0" + hours;
  }

  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return (hours + ":" + minutes + timeSuffix);
};
export const getTimeFormat = (date, timeZone = undefined) => {
  // date - the original received UTC date from db
  // timeZone - the received time zone to convert to
  // localTime - the date after convertion to local time 
  // convertedDate - converts the local time to the specified time zone
  // (takes in account EDT (Eastern Daylight Time) / DST (Daylight Saving Time))
  let localTime = convertUTCToLocalTime(date);
  let convertedDate = new Date(localTime).toLocaleTimeString('en-US', { hour12: true, timeZone }); 

  let timeSuffix = convertedDate.slice(-2);
  let hours = parseInt(convertedDate.split(":")[0]); 
  let minutes = parseInt(convertedDate.split(":")[1]);
  
  if (hours < 10) {
    hours = "0" + hours;
  }

  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return (hours + ":" + minutes + timeSuffix);
};

export const getValidateParkTimeFormat = (dateString) => {
  let date = new Date(dateString).toLocaleDateString("en-US"); // month/day/year
  let time = new Date(dateString).toLocaleTimeString("en-US"); // h:m:s am / pm
  let timeSuffix = time.toLocaleLowerCase().split(" ")[1];     // am / pm
  let len = time.toLocaleLowerCase().split(" ")[0].length;
  let timeWithoutSeconds = time.split(" ")[0].slice(0, len - 3);

  return `${date} ${timeWithoutSeconds} ${timeSuffix}`;
};

// added
export const timeStringToMins = (time) => {
  let string = time.split(":");
  return Number(string[0]) * 60 + Number(string[1]);
};

// added
export const minutesToString = (time) => {
  return Math.trunc(time / 60) + ":" + ("00" + (time % 60)).slice(-2);
};

export const convertCurrencyToSymbol = (currency) => {
  switch (currency) {
    case CURRENCIES.USD:
      return "$";
    case CURRENCIES.ILS:
      return "₪";
    default:
      return "$";
  }
};

export const flattenObj = (ob) => {
  let result = {};
  for (const i in ob) {
    if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
      const temp = flattenObj(ob[i]);
      for (const j in temp) {
        result[i + "." + j] = temp[j];
      }
    } else {
      result[i] = ob[i];
    }
  }
  return result;
};

// Receives two objects to compare and returns true if they are the same
// by comparing with stringify
export const isSameObj = (primaryObj, secondaryObj) => {
  return JSON.stringify(primaryObj) === JSON.stringify(secondaryObj);
};

export const getSiteIconName = (siteClientId) => {
  return `SITE_${siteClientId}`;
};

export const getDistIconName = (distClientId) => {
  return `DIST_${distClientId}`;
};

export const getBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
  };
};

export const phoneNumberToSend = (dialingCode, fullPhoneNumber) => {
  let result = fullPhoneNumber;
  // removes the '0' start of israeli phone numbers (only if dialing code is IL)
  if (dialingCode === DIALING_CODES.IL && fullPhoneNumber?.charAt(0) === "0") {
    result = fullPhoneNumber?.slice(1);
  }

  return result;
};

export const fixIsraeliPhoneNumber = (fullPhoneNumber) => {
  var fixedFullPhoneNumber =
    fullPhoneNumber?.charAt(3) === "0"
      ? fullPhoneNumber?.slice(0, 3) + fullPhoneNumber?.slice(4)
      : fullPhoneNumber;

  return fixedFullPhoneNumber;
};

export const getPhoneNumberDialingCodePrefix = (fullPhoneNumber) => {
  return fullPhoneNumber?.startsWith(DIALING_CODES.IL) ? DIALING_CODES.IL : DIALING_CODES.US
};

export const removePhoneNumberPrefix = (fullPhoneNumber) => {
  var fixedFullPhoneNumber = fullPhoneNumber?.startsWith(DIALING_CODES.IL)
    ? "0" + fullPhoneNumber?.slice(3) // handle IL dialing code
    : fullPhoneNumber?.slice(1); // handle US dialing code

  return fixedFullPhoneNumber;
};

export const removeETicketPrefix = (cars) => {
  cars.forEach(car => {
    if (car.licensePlate.startsWith('ETicketCar-')) {
      car.licensePlate = car.licensePlate.split('-')[1];
    }
    if (car.nickname.startsWith('ETicketCar-')) {
      car.nickname = car.nickname.split('-')[1];
    }
  });

  return cars;
};

export const removeDuplicatesInArray = (arr) => {
  return arr.filter((item, index) => arr.indexOf(item) === index);
};

// Receives string and remove its html tags
export const removeHtmlTags = (str) => {
  return str?.replace(/(<([^>]+)>)/ig, "");
};

// Receives string and returns array of founded open and closing html tags
export const getHtmlTags = (str) => {
  return str?.match(/<[^>]*?>/g);
};

// Decodes html escaped string
// isDisplay - when is for display - encoded space (&nbsp;) will be replaced for
// " " instead "" (example: for a counter usage)
export const getDecodedHtmlString = (str, isDisplay = false) => {
  return str
    .replace(/&nbsp;/g, isDisplay ? " " : "")
    .replace(/&amp;/g, "&")
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<");
};

export const getProgressBarValue = (currentStepNumber) => {
  return (100 / ADD_PARKER_FORM_STEPS.TOTAL_STEPS) * currentStepNumber;
};
export const getBillingProgressBarValue = (currentStepNumber) => {
  return (
    (100 / ADD_BILLING_RULE_FORM_STEPS.ADD_BILLING_RULE_TOTAL_STEP) *
    currentStepNumber
  );
};

// Receives camel case string and converts to words string with upper case for every word start
export const camelCaseToTitleCaseString = (camelString) => {
  return camelString = camelString.replace(/[A-Z]/g, " $&"), camelString[0].toUpperCase() + camelString.slice(1);
};

// Receives capitalized string and converts to words string with upper case for every word start
export const capitalCaseToTitleCaseString = (capitalizedString) => {
  return capitalizedString.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
};

// Receives decimal number as string, returns the sliced string number up to limit param
export const getDecimalNumberStringByLimit = (value, limit) => {
  return value?.includes(".") ? value.slice(0, (value.indexOf(".")) + limit + 1) : value;
};

export const getAddParkingAllocationBarValue = (currentStepNumber) => {
  // In this case step number starts from 2   ----> (currentStepNumber-1)
  return (100 / ADD_PARKING_ALLOCATION_STEPS.TOTAL_STEPS) * (currentStepNumber-1);
};

export const getStoreAsync = () => {
  return new Promise((resolve, reject) => {
    import('../redux/Store')
    .then((res) => {
      resolve(res.default);
    })
    .catch(err => {
      reject(err);
    });
  });
};

export const createGuid = () => {
  function p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return p8() + p8(true) + p8(true) + p8();
};

//Extensions
String.prototype.format = function () {
  var args = arguments;
  return this.replace(/{([0-9]+)}/g, function (match, index) {
    return typeof args[index] == "undefined" ? match : args[index];
  });
};
